export default __webpack_public_path__ + "static/media/large-city.1244502c.jpg";